<template>
<div>
	<TopAppBarDrawer></TopAppBarDrawer>
	<main class="main-wrapper flex-grow-1">	
		<div class="container container--small pdt-50 ">
			<div class="t-headline10 font-b mgb-8 pdl-24 pdr-24">{{$t('364')}}</div>
			<div class="t-body1 t-color-bodyGrayA font-r pdl-24 pdr-24">{{$t('410')}} </div>
			<form @submit.prevent="changePassword" novalidate>
			<div class="mgt-40 pdl-24 pdr-24 position-relative">
				<input type="hidden"
					v-model="findPw.password"
					name="password"
					ref="password"
				>
				<label
					class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
					data-mdc-auto-init="MDCTextField"
					:class="submitState && passwordConfirmInvalidCheck ? 'mdc-text-field--invalid' : ''"
					id="passwordConfirmEl">
					<span class="mdc-notched-outline">
									<span class="mdc-notched-outline__leading"></span>
									<span class="mdc-notched-outline__notch">
													<span class="mdc-floating-label font-r t-body6" id="my-label-id">{{$t('411')}}</span>
									</span>
									<span class="mdc-notched-outline__trailing"></span>
					</span>
					<input class="mdc-text-field__input font-r t-body6" 
						type="password"
						aria-labelledby="my-label-id"
						id="passwordConfirm"
						name="passwordConfirm"
						v-model="passwordConfirm"
						v-validate="'required|confirmed:password'"
						data-vv-as="password"
						ref="passwordConfirm"
					>
					<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
									role="button"
									:class="validIcon === 'check' ? 'check_show' : ''"
									>{{validIcon}}</i>
				</label>
				<div class="mdc-text-field-helper-line d-block">
					<div class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r " :class="submitState && passwordConfirmInvalidCheck ? 't-color-textfieldError' : ''">
						{{$t('412')}}
					</div>
				</div>
			</div>
			<div class="mgt-31 pdl-24 pdr-24">
				<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">	{{$t('413')}}</span>
				</button>
				<button class="mdc-button t-color-secondaryBtnText"  @click="cancelPw()" @keypress="cancelPw()" tabindex="0">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{$t('414')}}</span>
				</button>
			</div>
			</form>
		</div>
	</main>
</div>
</template>

<script>
/**
 * 비밀번호 재설정 Step5 컴포넌트 (reset password Step5 component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import findApi from '@/api/findApi.js'
import {mapState, mapMutations} from 'vuex'
import {findIdMixin} from '@/mixins/findId.js'
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
export default {
	data() {
		return {
			passwordConfirm: '',
			passwordConfirmTextField: null,
			submitState: false,
			validIcon: ''
		}
	},

	mixins: [findIdMixin],

	computed: {
		...mapState('findPw',{
			findPw : state => state,
		}),
	components:{
		TopAppBarDrawer
	},
		// 패스워드 확인 유효성 체크(validation password confirm)
		passwordConfirmInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('passwordConfirm')) {
					returnValue = true
					this.validIcon = 'warning'
				}else {
					returnValue = false
					this.validIcon = 'check'
				}
			}

			this.passwordConfirmTextField.valid === !returnValue ? '' : this.passwordConfirmTextField.valid = !returnValue
			return returnValue
		}
	},

	mounted() {
		// 토큰값이 없을 경우 Step1로 이동(If there is no token value, go to Step1)
		if (!this.findPw.step3.token) {
			this.$moveLogin()
		}

		this.setMaterialUi()
		this.$refs.passwordConfirm.focus()
	},

	methods: {
		
		// Store 변이 정의(define store mutation)
		...mapMutations('findPw', ['INIT_FINDPW_STORE']),

		setMaterialUi() {
			window.mdc.autoInit();
			const selector = '.mdc-button, .mdc-list, .mdc-list-item, .mdc-card__primary-action, .mdc-chip-set';
			if(document.querySelector('.mdc-text-field')){
				var textField = new MDCTextField(document.querySelector('.mdc-text-field'));
			}
			this.passwordConfirmTextField = new MDCTextField(document.querySelector('#passwordConfirmEl'))
			this.passwordConfirmTextField.useNativeValidation = false

			const buttonRipple = [].map.call(document.querySelectorAll(selector), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},

		// 비밀번호 변경(reset password)
		changePassword() {
			this.$validator.validateAll().then((resultValid) => {
				this.submitState = true
				if (resultValid) {
					let responseData = null

					let params = {
						token: this.findPw.step3.token,
						value: this.findPw.certiNumber,
						newPassword: this.findPw.password
					}

					findApi.changeFindPw(params).then((response) => {

						responseData = response.data.data
						if (responseData) {
							this.$alert({
								title: this.$t('421'), //비밀번호 변경 완료
								//content: this.$t('422') + ' ' +this.$t('415'), //새로운 비밀번호로 변경이 완료되었습니다. 다시 로그인해주세요.
								content: this.$t('422'), //새로운 비밀번호로 변경이 완료되었습니다. 다시 로그인해주세요.
								accept:  this.$t('423'),
							}).then(() => {
								this.INIT_FINDPW_STORE()
								this.$router.push({
									name: 'MyInformation', 
								}) 
							})
						} else{
							this.$error({
								// content: '비밀번호 변경중 오류가 발생했습니다.',
								content: this.$t('957'),
								accept:  this.$t('423'),
							}).then(() => {
									this.$router.push({
										name: 'MyInformation', 
									})
								})
						}

					}).catch((err) => {
						responseData = err.response.data.meta
						this.$error({content: responseData.errMsg}).then(() => {
								this.$router.push({
									name: 'MyInformation', 
								})
							})
					})
				}else {
					this.$refs.passwordConfirm.focus()
				}
			})
		},

		cancelPw() {
			this.$router.push({
				name: 'MyInformation', 
			})
		}
	},
}
</script>
<style scoped>
.check_show{
	display: block !important;;
}

</style>